
/**
 * publish
 * @param  {Any} ...args
 * @return {Function}
 */
function publish(...args) {
    return function(target, name, descriptor) {

    }
}

/**
 * subscribe
 * @param  {Any} ...args
 * @return {Function}
 */
function subscribe(...args) {
    return function(target, name, descriptor) {

    }
}

export {
    publish,
    subscribe
};
